// import formatDate from "../../../utils/formatDate";

export const REVIEW_COLUMNS = [
  {
    header: "id",
    id: "id",
    accessorKey: "id",
  },
  {
    header: "Manager",
    id: "manager",
    accessorKey: "manager",
  },
  {
    header: "Title",
    id: "title",
    accessorKey: "title",
  },
  {
    header: "Year",
    id: "year",
    accessorKey: "year",
  },
  {
    header: "templateVersionId",
    id: "templateVersionId",
    accessorKey: "templateVersionId",
  },
  {
    header: "dateCompleted",
    id: "dateCompleted",
    accessorKey: "dateCompleted",
  },
  {
    header: "dateToCompleteBy",
    id: "dateToCompleteBy",
    accessorKey: "dateToCompleteBy",
  },
  {
    header: "status",
    id: "status",
    accessorKey: "status",
  },
  {
    header: "userId",
    id: "userId",
    accessorKey: "userIds",
  },
];

export const FOLLOWUPS_COLUMNS = [
  {
    header: "Partner Last Name",
    id: "lastName",
    accessorKey: "lastName",
  },
  {
    header: "Partner First Name",
    id: "firstName",
    accessorKey: "firstName",
  },
  {
    header: "Group",
    id: "group",
    accessorKey: "group",
  },
  {
    header: "Partner ID",
    id: "employeeNumber",
    accessorKey: "employeeNumber",
  },
  {
    header: "Manager ID",
    id: "manager",
    accessorFn: ( row ) =>
      `${row?.supervisorObj?.employeeNumber}`
  },
  {
    header: "Assigned to",
    id: "assignedTo",
    accessorFn: ( row ) => {
      const assignedUsers = row?.followups
        ?.filter(followup => followup.assignedToUser)
        ?.map(followup => `${followup.assignedToUser.firstName} ${followup.assignedToUser.lastName}`)
        ?.filter((value, index, self) => self.indexOf(value) === index); // Remove duplicates
      return assignedUsers?.length > 0 ? assignedUsers.join(", ") : "Not assigned";
    }
  },
];

export const ASSIGNED_FOLLOWUPS_COLUMNS = [
  {
    header: "Title",
    id: "title",
    accessorKey: "title",
  },
  {
    header: "Description",
    id: "description",
    accessorKey: "description",
  },
  {
    header: "Partner",
    id: "partner",
    accessorFn: ( row ) =>
      `${row?.user?.firstName} ${row?.user?.lastName}`
  },
  {
    header: "Partner ID",
    id: "partnerEmployeeNumber",
    accessorFn: ( row ) =>
      `${row?.user?.employeeNumber}`
  },
  {
    header: "Group",
    id: "group",
    accessorFn: ( row ) =>
      `${row?.user?.group}`
  },
  {
    header: "Status",
    id: "status",
    accessorKey: "status",
  },
  {
    header: "Created By",
    id: "createdBy",
    accessorKey: "createdBy",
  },
]; 